<template>
  <div v-if="isLoaded && conference_module">
    <div
        class="content-body"
        v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Consulta e Manutenção de Inventário</h4>
              <a class="heading-elements-toggle"
              ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
              ></i
              ></a>
              <div
                  class="heading-elements"
                  v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a @click="onCreate()" v-b-tooltip title="Agrupar"
                    ><i class="fa fa-check"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="openInventoryModal(null)"
                        v-b-tooltip
                        title="Agrupar volume por bip"
                    ><i class="fa fa-plus"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onFilterReset()"
                        v-b-tooltip
                        title="Atualizar listagem"
                    ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="expandFullscreenFw()"
                        v-b-tooltip
                        title="Expande a tela"
                        v-if="!isFullscreen"
                    ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="expandFullscreenFw()"
                        v-b-tooltip
                        title="Minimiza a tela"
                        v-if="isFullscreen"
                    ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                        @click="onFilterShowHideFw()"
                        v-b-tooltip.hover.left="'Filtros'"
                    ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar></vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div v-if="loadingData" class="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                          v-if="loadingData"
                          text-fg-color="#ffffff"
                          message="Carregando..."
                      ></spinner>
                    </div>
                  </div>

                  <div>
                    <a
                        @click="selectedAll"
                        v-b-tooltip
                        title="Selecionar todas as páginas"
                    ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0 0 5px 4px"
                    ></i>
                    </a>
                  </div>

                  <vuetable
                      ref="vuetable"
                      :key="tableKey"
                      :load-on-start="false"
                      api-url="/api/inventario"
                      :fields="fields"
                      :css="css"
                      :append-params="filterParams"
                      track-by="docfisvol_id"
                      pagination-path="meta"
                      no-data-template="Nenhum dado encontrado. Escolha um filtro indicado ou atualize a página."
                      @vuetable:load-error="onError"
                      @vuetable:pagination-data="onPaginationData"
                      @vuetable:loaded="onLoaded"
                      class="table-responsive-sm"
                  >
                    <template v-slot:actions="props">
                      <a
                          v-if="props.rowData.grupo.status && parseInt(props.rowData.status_volume.valor) === InvoiceVolumeStatusEnum.INVENTORY_MANAGEMENT_IN_PROGRESS"
                          @click="openInventoryModal(props.rowData)"
                          v-b-tooltip
                          title="Adicionar volume ao grupo"
                      ><i class="fa fa-file"></i
                      ></a>
                      <div class="custom-actions"></div>
                    </template>
                  </vuetable>

                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          v-if="filterApplied"
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          v-if="filterApplied"
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConsultaInventarioModal ref="consultaInventarioModal" @invoiceVolumeInsertOrRemoved="refreshTable"/>
    </div>
  </div>
</template>
<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import ConsultaInventarioFilter from "./ConsultaInventarioFilter.vue";
import {buildQueryParams, documentFormat, formatToBrazilianDate} from "../utils";
import {InvoiceVolumeGroupStatusEnum, InvoiceVolumeStatusEnum} from "../enums/GeneralEnums";
import ConsultaInventarioModal from './ConsultaInventarioModal.vue'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    ConsultaInventarioModal,
    "vuetable-filterbar": ConsultaInventarioFilter,
  },
  data() {
    return {
      tableKey: 0,
      loadingData: false,
      filterApplied: false,
      filterParams: {},
      docfisvols: [],
      form: new Form({
        docfisvols: [],
      }),
      filterForm: new Form({
        num_fiscal: "",
        num_volume: "",
        pallet_id: "",
        sku: "",
        cnpj_emi: "",
        pedido: "",
        ocorrencia: "",
        unidade: "",
        docfisvol_id: "",
        dt_inclusao_ini: "",
        dt_inclusao_fim: "",
        invoiceVolumeGroupStatus: [],
        per_page: '',
      }),
      helpForm: new Form({recordCollection: [], status: ""}),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_fiscal",
          title: "N° da nota fiscal",
        },
        {
          name: "num_volume",
          title: "N° do volume bipado",
        },
        {
          name: "sku",
          title: "Sku",
          callback: (value) => (value.length ? value.join(", ") : "N/A"),
        },
        {
          name: "emissor_nf",
          title: "Emi.da nota fiscal",
          callback: (value) => documentFormat(value)
        },
        {
          name: "razao_social_emissor_nf",
          title: "Emi. Razão Social",
        },
        {
          name: "pedido",
          title: "Pedido",
        },
        {
          name: "ocorrencia",
          title: "Ocorrência",
        },
        {
          name: "unidade",
          title: "Unidade",
        },
        {
          name: "usuario_inclusao",
          title: "Usuário",
          callback: (value => value ? value.email : "N/A")
        },
        {
          name: "data_inclusao",
          title: "Data Inclusão",
          callback: (value) => formatToBrazilianDate(value)
        },
        {
          name: "status_volume",
          title: "Status",
          callback: (value) => this.formatStatus(value.valor)
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
    };
  },
  mounted() {
    this.$events.$on("filter-reset", () => this.onFilterReset());
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
  },
  methods: {
    onLoaded: function () {
      this.loadingData = false;
    },

    onCreate() {
      if (this.$refs.vuetable && this.$refs.vuetable.selectedTo.length > 0) {
        this.$Simplert.open({
          title: "Deseja realmente fazer o agrupamento?",
          message: "Ao agrupar todos os volumes selecionados, o grupo será automaticamente finalizado e os volumes removidos da tela de inventário.",
          customCloseBtnText: "Não",
          customConfirmBtnText: "Sim",
          useConfirmBtn: true,
          type: "warning",
          onConfirm: () => this.confirmCreateGrouping(),
          onClose: () => {
            this.loadingData = false
            this.$refs.vuetable.selectedTo = []
          }
        });
      } else {
        this.loadingData = false;
        return this.$Simplert.open({
          title: "Atenção",
          message: 'Selecione pelo menos um volume para o agrupamento ',
          customCloseBtnText: "Fechar",
          type: "warning",
        })
      }
    },
    confirmCreateGrouping() {
      this.form.docfisvols = [];
      this.loadingData = true;
      this.$refs.vuetable.selectedTo.map((volume) => this.form.docfisvols.push(volume));
      this.form
          .post('/api/inventario/agrupar')
          .then((response) => {
            new ReturnApi(response, this, true, null, null, false)
            this.$refs.vuetable.selectedTo = []
            Vue.nextTick(() => {
              if (this.$refs.vuetable) {
                this.$refs.vuetable.refresh();
              }
            });
          })
          .catch((error) => {
            new ReturnApi(error, this, true, null, null, false);
            this.loadingData = false;
            this.$refs.vuetable.selectedTo = []
            return this.$Simplert.open({
              title: "Atenção",
              message: error.message,
              customCloseBtnText: "Fechar",
              type: "error",
            })
          });
    },

    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },

    selectedAll(dataFilter, type) {
      if (type === 2) {
        this.filter_data_store = dataFilter;
      }

      if (type !== 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length === 0) {
          this.filterParams.per_page = null;
          this.filterForm
              .get(`/api/inventario?${buildQueryParams(this.filterParams)}`)
              .then((response) => {
                new ReturnApi(response, this, true, false, false);
                response.data.forEach((volume) => {
                  this.$refs.vuetable.selectedTo.push(parseInt(volume.docfisvol_id));
                });
                this.loadingData = false;
              })
              .catch((errors) => {
                new ReturnApi(errors, this);
                this.loadingData = false;
              });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(dataFilter) {
      this.filterApplied = true;
      this.loadingData = true;

      this.onFilterParamsChanged({
        num_fiscal: dataFilter.invoiceNumber || null,
        unidade_id: dataFilter.units || null,
        dt_inclusao_ini: dataFilter.invoiceInclusionDateStart || null,
        dt_inclusao_fim: dataFilter.invoiceInclusionDateEnd || null,
        pallet_id: dataFilter.palletId || null,
        cnpj_emi: dataFilter.invoiceIssuer || null,
        tp_ocorrencia: dataFilter.volumeOccurrence || null,
        status: dataFilter.invoiceVolumeGroupStatus || null,
        cd_pedido: dataFilter.orderNumber || null,
        sku: dataFilter.volumeCode || null,
        per_page: dataFilter.perPage || 15,
      });

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.refresh();
        }
      });
      this.loadingData = false;
    },
    onFilterReset() {
      this.filterApplied = false;
      this.loadingData = true;
      this.filterParams = {};

      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.selectedTo = [];
          this.$refs.vuetable.resetData();
        }
        if (this.$refs.pagination) {
          this.$refs.pagination.changePage(1);
        }
        this.loadingData = false;
      });
    },
    onFilterParamsChanged(newFilterParams) {
      this.filterParams = {...newFilterParams}
    },

    openInventoryModal(data) {
      this.$refs.consultaInventarioModal.onShowModalToBeep(data)
    },
    onError(response) {
      this.loadingData = false;
      new ReturnApi(response.response, this, true, true, false);
    },
    formatStatus(value) {
      if (parseInt(value) === InvoiceVolumeStatusEnum.INVENTORY_MANAGEMENT_IN_PROGRESS) {
        return '<span class="badge badge-warning">Em separação</span>';
      }
      return '<span class="badge badge-secondary">Sem Agrupamento</span>';
    },
    refreshTable() {
      Vue.nextTick(() => {
        if (this.$refs.vuetable) {
          this.$refs.vuetable.reload();
        }
      });
    },
  },
  computed: {
    InvoiceVolumeStatusEnum() {
      return InvoiceVolumeStatusEnum;
    },
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    conference_module: {
      get() {
        return this.$store.getters.unidade_active.utiliza_modulo_conferencia;
      }
    },
  },
};
</script>
